module.exports = __webpack_public_path__ + "static/img/silhouette_02.73c6716.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_02.png
// module id = LMze
// module chunks = 0